import { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import { PurchaseRequestsRootPageDocument } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import MyPurchaseRequestsDataTable from 'modules/procurement/components/purchaseRequests/MyPurchaseRequestsDataTable'
import CollectionsBootstrap from 'modules/procurement/lib/My_purchasesCollectionsBootstrap'

const Container = () => {
  const { navigation } = useNavigation()
  const { pathname } = useLocation()
  const { data, loading, error } = useQuery(PurchaseRequestsRootPageDocument)

  useEffect(() => {
    track(trackingEvents.procurement.openMyPurchaseRequests)
  }, [])

  if (pathname === navigation.myPurchases.newRequest.fullPath()) return <Outlet />

  const canManagePurchaseRequests = data?.procurement?._policies?.purchaseRequestCreate.can ?? false
  const hasFeaturePurchaseRequest =
    data?.companies.featureAvailabilitiesConnection.edges[0]?.node?.available ?? false

  return pathname !== navigation.myPurchases.fullPath() ? (
    <Outlet />
  ) : (
    <ResponsivePage.Body
      variant="full"
      loading={loading}
      error={error}
      authorized={canManagePurchaseRequests && hasFeaturePurchaseRequest}
    >
      <MyPurchaseRequestsDataTable />
    </ResponsivePage.Body>
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
